<template>
  <div class="kintaiTodokeShokai">
    <div>
      <el-row id="formArea">
        <el-col :span="12">
          <span class="selecterLabel">受付待ちのみ：</span>
          <el-switch v-model="showUketsuke" @change="uketsukeMode">
          </el-switch>
          <span class="selecterLabel">年月指定：</span>
          <el-switch v-model="showNengetsu" @change="nengetsuMode">
          </el-switch>
          <el-button type="default" :disabled="!showNengetsu" @click="onChange(-1)" size="medium" icon="el-icon-arrow-left">前月</el-button>
          <el-date-picker v-model="form.nengetsu" type="month" :disabled="!showNengetsu" @change="onChange" format="yyyy年 M月" value-format="yyyy-MM" :editable="false" :clearable="false" class="nengetsu" size="medium"></el-date-picker>
          <el-button type="default" :disabled="!showNengetsu" @click="onChange(1)" size="medium">翌月 <i class="el-icon-arrow-right" /></el-button>
        </el-col>
        <el-col :span="6">
          <span class="selecterLabel">取消を含む：</span>
          <el-switch v-model="showTorikeshi">
          </el-switch>
        </el-col>
        <el-col :span="6">
          <el-button type="success" @click="onKakunin()" size="medium">労務確認</el-button>
          <el-button type="danger" @click="onTorikeshi()" size="medium">届出取消</el-button>
        </el-col>
      </el-row>
    </div>
    <div id="selectButtons">
    </div>
    <el-table id="jokyoShokaiTable" ref="jokyoShokaiTable" :data="filteredList"
        :height="tableHeight" v-loading="loading" stripe border>
      <el-table-column type="selection" width="40"></el-table-column>
      <el-table-column label="修正" width="40" class="buttonCell">
        <template slot-scope="scope">
          <el-button icon="el-icon-finished" size="mini" @click="onShusei(scope.row)"></el-button>
        </template>
      </el-table-column>
      <el-table-column prop="kintaiTodokeBango" label="番号" width="65" sortable></el-table-column>
      <el-table-column prop="shainBango" label="社員番号" width="85" sortable></el-table-column>
      <el-table-column prop="shainShimei" label="社員氏名" width="120" sortable></el-table-column>
      <el-table-column prop="jokyoKubunMei" label="状況" width="105" sortable></el-table-column>
      <el-table-column prop="kimmuKubunMei" label="休暇区分" width="135" sortable></el-table-column>
      <el-table-column prop="koyoKeitai" label="雇用形態" width="135" sortable></el-table-column>
      <el-table-column prop="todokedeKubun" label="届出" width="60" sortable></el-table-column>
      <el-table-column prop="teishutsubi" label="提出日" width="95" sortable></el-table-column>
      <el-table-column prop="kaishiBi" label="開始日" width="95" sortable></el-table-column>
      <el-table-column prop="shuryoBi" label="終了日" width="95" sortable></el-table-column>
      <!--
      <el-table-column prop="kyujitsuShukinBi" label="休日出勤日" width="95"></el-table-column>
      -->
      <el-table-column prop="kaishiJikoku" label="開始時刻" width="67"></el-table-column>
      <el-table-column prop="shuryoJikoku" label="終了時刻" width="67"></el-table-column>
      <el-table-column prop="gokeiJikan" label="合計時間" width="67"></el-table-column>
      <el-table-column prop="jiyu" label="事由" width="200"></el-table-column>
      <el-table-column prop="biko" label="備考欄" width="200"></el-table-column>
      <el-table-column prop="fileName" label="添付" width="200">
        <template slot-scope="scope">
          <a v-for="(wfId, index) in scope.row.wfIdList" :key="wfId" target="_wf"
            :href="`https://portal.${form.gyomuHokoku.domain}/cgi-bin/dneo/zflow.cgi?cmd=flowindex&log=on#cmd=flowdisp&id=${wfId}`">
            {{scope.row.wfSubjectList[index]}}
          </a>
          <a href="javascript:void(0)" @click="downloadAttachedFile(scope.row.kintaiTodokeBango)" class="link">{{ scope.row.fileName }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="denwaBango" label="電話番号" width="120"></el-table-column>
    </el-table>

    <KintaiTodokeShusei :shuseiDialogVisible.sync="shuseiDialogVisible" :kintaiTodokeBango.sync="shuseiKintaiTodokeBango" @close-shusei-dialog="onCloseShuseiDialog" />
  </div>
</template>

<script>
import { notifySuccess, notifyWarning, notifyError, downloadFile } from '../utils.js'
import KintaiTodokeShusei from '../components/KintaiTodokeShusei.vue'

export default {
  name: 'KintaiTodokeShokai',
  components: {
    KintaiTodokeShusei,
  },
  data() {
    return {
      form: {
        nengetsu: '',
        kintaitodokeList: [],
      },
      tableHeight: 0,
      targetRow: null,
      shuseiKintaiTodokeBango: '',
      showUketsuke: true,
      showNengetsu: false,
      showTorikeshi: false,
      shuseiDialogVisible: false,
      loading: true
    }
  },
  computed: {
    filteredList() {
      return this.form.kintaitodokeList.filter(data => (this.showTorikeshi || data.jokyoKubun != '81'));
    },
  },
  created() {
    if (this.$route.params.nengetsu === undefined) {
      this.form.nengetsu = this.$parent.getNengetsu();
    } else {
      this.form.nengetsu = this.$route.params.nengetsu;
    }
    this.getData();
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      //this.tableHeight = window.innerHeight - 180;
      this.tableHeight = document.documentElement.clientHeight - 180;
    },
    uketsukeMode() {
      this.showNengetsu = !this.showUketsuke;
      this.getData();
    },
    nengetsuMode() {
      this.showUketsuke = !this.showNengetsu;
      this.getNengetsuData();
    },
    getData() {
      this.loading = true;
      this.$axios.get('/gwr/kintaitodoke/romu')
          .then((response) => {
            this.form.kintaitodokeList = response.data;
            this.loading = false;
            this.handleResize();
          })
          .catch((error) => {
            notifyError(this, error, 'データ取得エラー');
          });
    },
    getNengetsuData() {
      this.loading = true;
      this.$axios.get('/gwr/kintaitodoke/nengetsu/' + this.form.nengetsu)
          .then((response) => {
            this.form.kintaitodokeList = response.data;
            this.loading = false;
            this.handleResize();
          })
          .catch((error) => {
            notifyError(this, error, 'データ取得エラー');
          });
    },
    onChange(offset) {
      if (offset !== undefined) {
        this.form.nengetsu = this.$moment(this.form.nengetsu).add(offset, 'M').format('YYYY-MM');
      }
      this.$parent.setNengetsu(this.form.nengetsu);
      this.getNengetsuData();
    },
    onDownload(shori) {
      this.loading = true;
      let kintaitodokeList = [];
      this.$refs.jokyoShokaiTable.selection.forEach(shain => {
        kintaitodokeList.push(shain.shainId);
      });
      if (kintaitodokeList.length == 0) {
        notifyWarning(this, '選択', '出力対象の社員を選択してください。');
        return;
      }

      let params = new URLSearchParams();
      params.append('nengetsu', this.form.nengetsu);
      params.append('kintaitodokeList', kintaitodokeList);

      this.$axios.post('/gwr/gyomu/' + shori, params, { responseType: 'blob' })
        .then((response) => {
          downloadFile(this, response);
          this.getData();
        })
        .catch((error) => {
          notifyError(this, error, 'ダウンロードエラー');
        });
    },
    onKakunin() {
      this.changeJokyo("ikkatsuKakunin", "51", "労務受付待ち", "確認");
    },
    onTorikeshi() {
      this.changeJokyo("ikkatsuTorikeshi", "", "", "取消");
    },
    changeJokyo(url, taishoKubun, taishoKubunMei, shoriMei) {
      let kintaitodokeList = [];
      let isNotTaishoKubun = false;
      this.$refs.jokyoShokaiTable.selection.forEach(kintaitodoke => {
        if (taishoKubun && taishoKubun.indexOf(kintaitodoke.jokyoKubun) == -1) {
          isNotTaishoKubun = true;
        }
        kintaitodokeList.push(kintaitodoke.kintaiTodokeBango);
      });
      if (kintaitodokeList.length == 0) {
        notifyWarning(this, '選択', shoriMei + '対象の社員を選択してください。');
        return;
      }
      else if (isNotTaishoKubun) {
        notifyWarning(this, 'エラー', '「' + taishoKubunMei + '」以外は' + shoriMei + 'できません。');
        return;
      }

      this.$confirm(kintaitodokeList.length + '件分の勤怠届を' + shoriMei + 'します。よろしいですか？', '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'info'
      }).then(() => {
        this.loading = true;
        let params = new URLSearchParams();
        params.append('kintaitodokeList', kintaitodokeList);

        this.$axios.post('/gwr/kintaitodoke/' + url, params)
            .then(() => {
              notifySuccess(this, '処理完了', shoriMei + 'しました。');
              if (this.showUketsuke) {
                this.getData();
              } else {
                this.getNengetsuData();
              }
            })
            .catch((error) => {
              notifyError(this, error, 'データ登録エラー');
            });
      });
    },
    downloadAttachedFile(bango) {
      this.loading = true;
      this.$axios.get('/gwr/kintaitodoke/downloadAttachedFile/' + bango, { responseType: 'blob' })
        .then((response) => {
          downloadFile(this, response);
        })
        .catch((error) => {
          notifyError(this, error, 'データ取得エラー');
        });
    },
    onShusei(row) {
      this.shuseiKintaiTodokeBango = row.kintaiTodokeBango;
      this.shuseiDialogVisible = true;
    },
    onCloseShuseiDialog(isUpdate) {
      this.shuseiDialogVisible = false;
      if (isUpdate) {
        if (this.showUketsuke) {
          this.getData();
        } else {
          this.getNengetsuData();
        }
      }
    },
  },
}
</script>

<style scoped>
#formArea {
  width: 1310px;
  margin-left: auto;
  margin-right: auto;
  line-height: 35px;
}
#selectButtons {
  width: 1310px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 10px;
  text-align: left;
  border-top: 1px solid rosybrown;
}
.selecterLabel {
  margin-left: 20px;
  font-size: 14px;
  font-weight: bold;
}
#jokyoShokaiTable {
  width: 1880px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  margin-bottom: 30px;
  font-size:14px;
  border-color: lightgray;
}
#jokyoShokaiTable >>> th {
  padding: 0px 0px;
  background-color: whitesmoke;
  border-color: lightgray;
  color: dimgray;
}
#jokyoShokaiTable >>> th div {
  padding: 0px 0px;
  text-align: center;
}
#jokyoShokaiTable >>> td {
  padding: 0px 0px;
  border-color: lightgray;
}
#jokyoShokaiTable >>> td div:has(> .el-button--mini) {
  padding: 0px 0px;
  text-align: left;
}
#jokyoShokaiTable >>> .el-button--mini {
  padding: 4px 10px;
}
.el-button {
  margin: 0px 1px !important;
}
.nengetsu {
  width: 140px;
  margin-bottom: 10px;
}
.comment-tooltip {
  white-space: pre;
  font-size: 14px;
}
</style>
